import styled from 'styled-components';

export const OverlayTitle = styled.h3`
  line-height: ${props => props.theme.components.button.height}; // match the CloseButton height
`;
